import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Firebase
import { storage, db } from "../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { collection, doc, setDoc } from "firebase/firestore";

// Select
import Select from "react-select";

const durezaOptions = [
  { value: "facil", label: "Fácil" },
  { value: "media", label: "Media" },
  { value: "dificil", label: "Difícil" },
];

// ➕ NUEVAS OPCIONES: Modalidad
const modalidadOptions = [
  { value: "gravel", label: "Gravel" },
  { value: "carretera", label: "Carretera" },
  { value: "montaña", label: "Montaña" },
];

function CrearRuta() {
  const navigate = useNavigate();

  const [nombreInput, setNombre] = useState("");
  const [distanciaInput, setDistancia] = useState("");
  const [descripcionInput, setDescripcion] = useState("");
  const [durezaInput, setDureza] = useState("");
  // ➕ NUEVO ESTADO: Modalidad
  const [modalidadInput, setModalidad] = useState("");

  const [pictureURL, setPictureUrl] = useState("");
  const [gpxURL, setGpxURL] = useState("");

  const [isLoadingPicture, setIsLoadingPicture] = useState(false);
  const [isLoadingGPX, setIsLoadingGPX] = useState(false);

  const maxCharacters = 6000;

  // Handlers
  const handleNombreChange = (e) => setNombre(e.target.value);
  const handleDistanciaChange = (e) => setDistancia(e.target.value);
  const handleDescripcionChange = (e) => setDescripcion(e.target.value);
  const handleDurezaChange = (selectedOption) => setDureza(selectedOption.value);
  // ➕ NUEVO HANDLER: Modalidad
  const handleModalidadChange = (selectedOption) => setModalidad(selectedOption.value);

  const handlePictureChange = async (e) => {
    setIsLoadingPicture(true);
    const image = e.target.files[0];

    try {
      const storageRef = ref(storage, `rutas/images/${image.name}`);
      const snapShot = await uploadBytes(storageRef, image);
      const downloadUrl = await getDownloadURL(snapShot.ref);
      setPictureUrl(downloadUrl);
      setIsLoadingPicture(false);
    } catch (error) {
      navigate("/error");
    }
  };

  const handleGPXChange = async (e) => {
    setIsLoadingGPX(true);
    const file = e.target.files[0];

    try {
      const storageRef = ref(storage, `rutas/gpx/${file.name}`);
      const snapShot = await uploadBytes(storageRef, file);
      const downloadUrl = await getDownloadURL(snapShot.ref);
      setGpxURL(downloadUrl);
      setIsLoadingGPX(false);
    } catch (error) {
      navigate("/error");
    }
  };

  const handleCreateRuta = async (e) => {
    e.preventDefault();

    try {
      const rutasRef = collection(db, "rutas");
      const newRutaDocRef = doc(rutasRef);

      await setDoc(newRutaDocRef, {
        id: newRutaDocRef.id,
        nombre: nombreInput,
        distancia: distanciaInput,
        dureza: durezaInput,
        modalidad: modalidadInput, 
        descripcion: descripcionInput,
        foto: pictureURL,
        gpx: gpxURL,
      });

      alert("Ruta creada correctamente");
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="general-container">
      <div className="form-container">
        <form onSubmit={handleCreateRuta}>
          <h3>Crear Ruta</h3>

          <div className="input-container">
            <input value={nombreInput} onChange={handleNombreChange} required />
            <label className={nombreInput && "filled"}>Nombre de la Ruta</label>
          </div>

          <div className="input-container">
            <input value={distanciaInput} onChange={handleDistanciaChange} required />
            <label className={distanciaInput && "filled"}>Distancia (km)</label>
          </div>

          <div className="input-container">
            <textarea
              id="descripcion"
              rows={Math.min(5, Math.max(2, descripcionInput.split("\n").length))}
              value={descripcionInput}
              onChange={handleDescripcionChange}
              maxLength={maxCharacters}
            />
            <label className={descripcionInput && "filled"} htmlFor="descripcion">
              Descripción
            </label>
            <p>Tienes {maxCharacters - descripcionInput.length} carácteres disponibles</p>
          </div>

          {/* DUREZA */}
          <div className="input-container">
            <div className="select-size">
              <div className="name-select">
                <h4>Dureza</h4>
              </div>
              <div className="select-input">
                <Select onChange={handleDurezaChange} options={durezaOptions} />
              </div>
            </div>
          </div>

          {/* ➕ MODALIDAD */}
          <div className="input-container">
            <div className="select-size">
              <div className="name-select">
                <h4>Modalidad</h4>
              </div>
              <div className="select-input">
                <Select onChange={handleModalidadChange} options={modalidadOptions} />
              </div>
            </div>
          </div>

          {/* FOTO */}
          <div className="uploader-pic">
          <h3>Selecciona una imagen</h3>
            <input onChange={handlePictureChange} type="file" name="picture" />
            <label htmlFor="picture">Product Picture</label>
          </div>
          {isLoadingPicture === true && <p>...loading picture</p>}
          {/* Show the upload picture in this form */}
          {pictureURL !== "" ? (
            <img
              src={pictureURL}
              alt="yourPic"
              width={200}
              className="uploader-img"
            />
          ) : (
            <p> [ No Picture Selected ]</p>
          )}
<br />
<hr />
          {/* GPX */}

          <div className="uploader-pic">
          <h3>Selecciona un archivo GPX</h3>

            <input onChange={handleGPXChange} type="file" />
            <label>Archivo GPX</label>
          </div>
          {isLoadingGPX && <p>subiendo gpx...</p>}
          {gpxURL !== "" ? (
            <img
              src={gpxURL}
              alt="yourPic"
              width={200}
              className="uploader-img"
            />
          ) : (
            <p> [ No GPX File Selected ]</p>
          )}

          <button type="submit" className="general-btn">
            Crear Ruta
          </button>
        </form>
      </div>
    </section>
  );
}

export default CrearRuta;